<template>
  <div class="wedding-editor" ref="editor">
    <header class="editor-header">
        <a href="javascript:;"></a>
        <a href="javascript:;" class="minimum"></a>
        <a href="javascript:;" class="maximum"></a>
    </header>
    
    <!--代码编辑区-->
    <pre class="festive-container">
      <div class="red-ribbon left-ribbon" :class="{ 'show': !showRibbons }"></div>
      <div class="red-ribbon right-ribbon" :class="{ 'show': !showRibbons }"></div>
      <code v-html="highlightedCode" class="golden-text"></code>
    </pre>
    <!-- 打开邀请函 -->
    <div
      class="editor-open"
      v-if="(canStart || hasClosed) && !canOpen"
      @click="canOpen = true"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="9" y1="3" x2="9" y2="21"></line>
      </svg>
    </div>
    <Executions :canExecute="canExecute" @onUpdating="scrollToBottom" @onFinish="canOpen = true"/>
    <invitation :canOpen="canOpen" @onClose="canOpen = false, hasClosed = true" @sendBarrage="onAfterSending"/>
    <Barrage :wish="wish" :canStart="canStart"/>
  </div>
</template>

<script>
  import Prism from 'prismjs'
  import 'prismjs/themes/prism-okaidia.css'
  import '../utils/raf'
  import data from '../mock/data'

  import Executions from './Executions'
  import Invitation from './Invitation'
  import Barrage from './Barrage'

  export default {
    name: 'Editor',
    components: { Executions, Invitation, Barrage },
    data() {
      return {
        startDate: '',
        code: data.code,
        currentCode: '',
        isCursorVisible: 0,
        canExecute: false,
        canOpen: false,
        wish: '',
        hasClosed: false,
        canStart: false,
        showRibbons: true
      }
    },
    created() {
      this.startDate = (new Date()).toDateString()
      this.progressivelyTyping()
      
      // 0.5秒后开始拉开红绸
      setTimeout(() => {
        this.showRibbons = false
      }, 500)
    },
    mounted() {
      // 3秒后强制显示打开按钮（无论执行流程如何）
      setTimeout(() => {
        this.canStart = true
      }, 3000)
      
      // 5秒后如果还没打开，也强制显示（备用方案）
      setTimeout(() => {
        if (!this.canOpen) {
          this.canStart = true
        }
      }, 5000)
    },
    updated() {
      this.scrollToBottom()
    },
    computed: {
      highlightedCode () {
        const code = Prism.highlight(
            this.currentCode,
            Prism.languages.javascript
          )
        return code
      }
    },
    methods: {
      scrollToBottom() {
        this.$refs.editor.scrollTop = 100000
      },
      progressivelyTyping() {
        return new Promise((resolve) => {
          const lines = this.code.split('\n')
          let currentLineIndex = 0
          let currentDisplay = ''
          
          let lineStep = () => {
            if (currentLineIndex < lines.length) {
              // 添加当前行（保留原有换行符）
              currentDisplay += lines[currentLineIndex]
              if (currentLineIndex < lines.length - 1) {
                currentDisplay += '\n'
              }
              this.currentCode = currentDisplay
              currentLineIndex++
              
              // 每行出现的速度
              const delay = 600
              
              setTimeout(() => {
                requestAnimationFrame(lineStep)
              }, delay)
            } else {
              this.canExecute = true
              resolve()
            }
          }
          
          requestAnimationFrame(lineStep)
        })
      },
      onAfterSending(wish) {
        this.wish = wish
        this.canOpen = false
        setTimeout(() => {
          this.canStart = true
        }, 800)
      }
    }
  }
</script>

<style lang="less">
.wedding-editor{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 15px;
  padding-top: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 10;
  background:transparent;

  .editor-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 12px;
    overflow: hidden;
    background: transparent;
    z-index: 3;
    >a{
      float: left;
      display: block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      border-radius: 8px;
      background: #FC615D;
      &.minimum{
        background: #FDBC40;
      }
      &.maximum{
        background: #34C84A;
      }
    }
  }
  
  .festive-date {
    color: #FFD700 !important;
    text-shadow: 0 0 5px rgba(255, 215, 0, 0.5);
    position: relative;
    z-index: 10;
  }
  
  p.code{
    margin: 0;
    color: #BBB;
    line-height: 1.2;
    font-family: 'Roboto Mono', 'Menlo', 'Monaco', Courier, monospace !important;
    font-weight: 500 !important;
    font-size: 16px!important;
  }
  
  .festive-container {
    position: relative;
    margin: 0;
    white-space: pre-wrap;
    min-height: 200px;
    overflow: hidden;
  }
  
  .red-ribbon {
    position: absolute;
    top: 0;
    width: 50%;
    height: 100%;
    background: linear-gradient(135deg, #FF4500, #FF1493);
    z-index: 20;
    transition: transform 1.5s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    
    &::after {
      content: "囍";
      position: absolute;
      color: rgba(255, 215, 0, 0.2);
      font-size: 100px;
      font-family: "SimSun", "宋体", serif;
      white-space: nowrap;
      transform: rotate(-15deg);
    }
  }
  
  .left-ribbon {
    left: 0;
    transform: translateX(0);
    
    &::after {
      bottom: 20px;
      right: 20px;
    }
    
    &.show {
      transform: translateX(-100%);
    }
  }
  
  .right-ribbon {
    right: 0;
    transform: translateX(0);
    
    &::after {
      top: 20px;
      left: 20px;
      transform: rotate(15deg);
    }
    
    &.show {
      transform: translateX(100%);
    }
  }
  
  pre {
    margin: 0;
    white-space: pre-wrap;
    background: transparent;
    
    code {
      white-space: pre-wrap;
      word-break: break-all;
      font-size: 16px!important;
      margin: 0;
      line-height: 1.2;
      font-family: 'Roboto Mono', 'Menlo', 'Monaco', Courier, monospace !important;
      font-weight: 500 !important;
      background: transparent;
      display: block;
      position: relative;
      z-index: 10;
    }
    
    .golden-text {
      color: #FFD700;
      text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
      animation: goldenGlow 3s ease-in-out infinite;
    }
  }
  
  .editor-open{
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 40px;
    height: 40px;
    padding: 6px;
    border-radius: 20px;
    text-align: center;
    line-height: 18px;
    border: 5px solid #FFD700;
    color: #FF4500;
    background: #FFF0F5;
    z-index: 1000;
    animation: pulse 2s ease-in-out infinite;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.1);
      box-shadow: 0 0 30px rgba(255, 215, 0, 0.8);
    }
  }
}

// 动画定义
@keyframes goldenGlow {
  0%, 100% {
    text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
  }
  50% {
    text-shadow: 0 0 20px rgba(255, 215, 0, 0.8), 0 0 30px rgba(255, 69, 0, 0.3);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(255, 69, 0, 0.5);
  }
}

// 为每行文字添加进入动画
pre code span {
  display: inline-block;
  animation: lineEnter 0.5s ease-out forwards;
  opacity: 0;
  transform: translateY(10px);
}

@keyframes lineEnter {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>